declare global {
  interface WindowEventMap {
    'vite:preloadError': Event;
  }
}

const LAST_RELOAD_KEY = 'staleChunkReloadAt';
const RELOAD_COOLDOWN_MS = 10000;

// A deploy drops the old hashed chunks, so tabs opened before it fail to lazy-load.
// Reload to pick up the current index.html; the cooldown guards against a reload loop.
window.addEventListener('vite:preloadError', () => {
  const lastReloadAt = Number(sessionStorage.getItem(LAST_RELOAD_KEY)) || 0;
  if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) {
    return;
  }
  sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
  window.location.reload();
});

export {};
